import React from "react";
import { useMediaQuery } from "react-responsive";
import platformIllustrationSrc from "../../assets/illustrations/home-platform.svg";
import platformIllustrationMobSrc from "../../assets/illustrations/home-platform-mob.svg";

const Platform = () => {
  const isDesktop = useMediaQuery({ minWidth: 1024 });

  return (
    <div className="px-5 lg:px-10 pt-16 lg:pt-30 pb-10 lg:pb-20 bg-navy -mb-1">
      <div className="w-full lg:max-w-7xl mx-auto text-white flex flex-col items-center">
        <h2 className="text-8 lg:text-5xl mb-10 leading-tight header text-center">
          The AI Platform for Asynchronous Care
        </h2>
        <div className="flex w-full max-w-full lg:max-w-5xl items-center justify-center">
          {isDesktop ? (
            <img
              src={platformIllustrationSrc}
              alt="platform"
              className="max-w-full object-fill object-center lg:min-w-full"
              width="1014"
              height="314"
            />
          ) : (
            <img
              src={platformIllustrationMobSrc}
              alt="platform"
              className="max-w-full object-fill object-center lg:min-w-full"
              width="335"
              height="614"
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default Platform;
